export default __webpack_public_path__ + "static/media/icon-0.b5416b1e.svg";